const colors = {
  transparent: 'transparent',
  black: '#172B4D',
  white: '#ffffff',
  text: '#343D48',
  textPrimary: '#172B4D',
  primary: '#7764E4',
  primaryHover: '#7764E4',
  border: '#8898AA',
  secondary: '#7764E4',
  tertiary: '#6D5CD1',
};

export default colors;
